import React, { useContext, useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../config/AuthContext";
import Login from "../../Login";
import { Content } from "antd/es/layout/layout";
import { Button, Progress, Table, TableProps, Tag, Card, Typography, Tooltip, Space, Spin, Input, Select, Row, Col } from "antd";
import { GetJutgeProblemes } from "../../../dao/jutge/GetJutgeProblemes";
import { ColumnsType } from "antd/es/table";
import JutgeColors from "../../../styles/JutgeColors";
import { BiArrowFromLeft, BiStats } from "react-icons/bi";
import AppSider from "../../jutge/components/AppSider";
import { BsEye, BsEyeSlash } from "react-icons/bs";
import { PutProblemesIdEstat } from "../../../dao/jutge/PutProblemesIdEstat";
import {IoIosCheckmark} from "react-icons/io";
import { Modal } from 'antd';
import ProblemaIdAlumnes from '../problemesId/content/ProblemaIdAlumnes';
import NouModal from '../activitatsId/content/NouModal';
import { BiPlus } from "react-icons/bi";

const { Title } = Typography;

const Problemes = () => {
    const { isLoggedIn, userId, user, setBreadCrumb } = useContext(AuthContext);
    const navigate = useNavigate();
    const [dades, setDades] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [filterDifficulty, setFilterDifficulty] = useState<string | null>(null);
    const [filterStatus, setFilterStatus] = useState<string | null>(null);
    const [filterTags, setFilterTags] = useState<string[]>([]);
    const [attemptsModalVisible, setAttemptsModalVisible] = useState(false);
    const [selectedProblemId, setSelectedProblemId] = useState<string | null>(null);
    const [modalNouVisible, setModalNouVisible] = useState(false);

    const isRole3 = String(user?.tipus) === "3";

    useEffect(() => {
        if (isLoggedIn) {
            if (isRole3) {
                setBreadCrumb([
                    { nom: 'problemes', nav: '/jutge/problemes' }
                ], true);
            } else {
                setBreadCrumb([
                    { nom: 'Home', nav: '/home' },
                    { nom: 'jutge', nav: '/jutge' },
                    { nom: 'problemes', nav: '/jutge/problemes' }
                ], true);
            }
            checkDades();
        }
    }, [isLoggedIn, isRole3]);

    async function checkDades(refresh: boolean = true) {
        if (refresh) setLoading(true);
        const data = await GetJutgeProblemes(userId);
        setDades(data);
        setLoading(false);
    }

    async function canviEstat(id: number) {
        //setLoading(true);
        await PutProblemesIdEstat(id);
        await checkDades(false);
    }

    const columns: ColumnsType<any> = [
        {
            key: 'id',
            dataIndex: 'id',
            width: 50,
            align: 'center',
            render: (id) => <Tag color={JutgeColors.colors.color5}>#{id}</Tag>
        },
        {
            key: 'nom',
            dataIndex: 'nom',
            width: 150,
            render: (text, ele) => (
                <div>
                    <strong style={{ fontSize: '1rem', color: JutgeColors.colors.color5 }}>{text}</strong>
                </div>
            )
        },
        {
            key: 'nom',
            dataIndex: 'nom',
            width: 200,
            render: (text, ele) => (
                <div>
                    {ele.tags && (
                        <div style={{ marginTop: '4px' }}>
                            {ele.tags.split(' ').map((t: string, i: number) => (
                                <Tag
                                    key={i}
                                    color={[JutgeColors.colors.color3, JutgeColors.colors.color4, JutgeColors.colors.color5, JutgeColors.colors.color6][i % 4]}
                                    style={{ fontSize: '0.75rem', borderRadius: '8px', marginBottom: '4px' }}
                                >
                                    {t}
                                </Tag>
                            ))}
                        </div>
                    )}
                </div>
            )
        },
        {
            key: 'progres',
            dataIndex: 'progres',
            width: 10,
            render: (e, ele) => {
                // Determinamos si tu progreso está completo o no
                const hecho = ele.propis === 100; // o si es 1/0 según tu lógica

                return (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>

                        {/* Progreso personal como icono */}
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            {hecho ? (
                                <span style={{ color: 'green', fontSize: '1.2rem' }}>
                                    <IoIosCheckmark style={{color: "green"}}/>
                                </span>
                            ) : (
                                <></>
                            )}
                        </div>
                    </div>
                );
            }
        },
        {
            key: 'intents',
            dataIndex: 'intents',
            width: 180,
            render: (e, ele) => {
                return (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                        {/* Progreso global con barra */}
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <div style={{ flex: 1 }}>
                                <Progress
                                    percent={Math.round((ele.encertats / ele.totals) * 100)}
                                    strokeColor={{
                                        '0%': JutgeColors.colors.color1,
                                        '50%': JutgeColors.colors.color2,
                                        '100%': JutgeColors.colors.color5,
                                    }}
                                    showInfo={true}
                                    strokeWidth={12}
                                />
                            </div>
                        </div>

                    </div>
                );
            }
        },
        {
            key: 'dificultat',
            dataIndex: 'dificultat',
            width: 100,
            render: (dificultat) => {
                let color = '';
                switch ((dificultat || '').toLowerCase()) {
                    case 'begginer':
                        color = JutgeColors.colors.color5; // verde
                        break;
                    case 'intermediate':
                        color = JutgeColors.colors.color3; // naranja
                        break;
                    case 'expert':
                        color = JutgeColors.colors.color1; // rojo
                        break;
                    default:
                        color = JutgeColors.colors.color3; // color por defecto
                }
                return <Tag color={color} style={{ fontSize: '0.8rem', borderRadius: '8px' }}>{dificultat || 'N/D'}</Tag>;
            }
        },
        {
            key: 'actions',
            dataIndex: 'actions',
            width: 100,
            render: (e, ele) => (
                <Space>
                    <Tooltip title="Accedir">
                        <Button
                            shape="circle"
                            icon={<BiArrowFromLeft />}
                            onClick={() => navigate(`${ele.id}`)}
                            style={{ backgroundColor: JutgeColors.colors.color6, border: 'none', color: '#fff' }}
                        />
                    </Tooltip>
                    {(user.tipus === "1" || user.tipus === "0") && (
                        <>
                            <Tooltip title="Canviar estat">
                                <Button
                                    shape="circle"
                                    onClick={() => canviEstat(ele.id)}
                                    icon={ele.estat === 1 ? <BsEye /> : <BsEyeSlash />}
                                    style={{
                                        backgroundColor: ele.estat === 1 ? JutgeColors.colors.color2 : JutgeColors.colors.color4,
                                        border: 'none',
                                        color: '#fff'
                                    }}
                                />
                            </Tooltip>
                            <Tooltip title="Veure intents de tothom">
                                <Button
                                    shape="circle"
                                    onClick={() => {
                                        setSelectedProblemId(ele.id.toString());
                                        setAttemptsModalVisible(true);
                                    }}
                                    icon={<BiStats />}
                                    style={{
                                        backgroundColor: JutgeColors.colors.color1,
                                        border: 'none',
                                        color: '#fff'
                                    }}
                                />
                            </Tooltip>
                        </>
                    )}
                </Space>
            )
        }
    ];

    const filteredDades = dades.filter(item => {
        const matchesName = item.nom.toLowerCase().includes(searchText.toLowerCase());
        const matchesDifficulty = !filterDifficulty || (item.dificultat || '').toLowerCase() === filterDifficulty.toLowerCase();
        
        const hecho = item.propis === 100;
        const matchesStatus = !filterStatus || 
            (filterStatus === 'hechos' && hecho) || 
            (filterStatus === 'no_hechos' && !hecho);

        const itemTags = item.tags ? item.tags.toLowerCase().split(' ') : [];
        const matchesTags = filterTags.length === 0 || filterTags.every(tag => itemTags.includes(tag.toLowerCase()));

        return matchesName && matchesDifficulty && matchesStatus && matchesTags;
    });

    // Extract unique tags for the tag filter
    const allTags = Array.from(new Set(dades.flatMap(item => item.tags ? item.tags.split(' ') : []))).sort();

    const tableProps: TableProps<any> = { loading };
    function setPnt(value: number) { }

    if (!isLoggedIn) return <Login />;

    return (
        <>
            <AppSider setPantalla={setPnt} currentVal={1} />
            <Content style={{ padding: '0 24px' }}>
                <Card
                    bordered={false}
                    style={{
                        boxShadow: '0 4px 15px rgba(0,0,0,0.08)',
                        background: '#fff',
                        marginBottom: '20px'
                    }}
                >
                    <Row gutter={[16, 16]} align="middle">
                        <Col xs={24} md={6}>
                            <Input 
                                placeholder="Filtrar per nom..." 
                                value={searchText} 
                                onChange={e => setSearchText(e.target.value)}
                                allowClear
                            />
                        </Col>
                        <Col xs={24} md={4}>
                            <Select
                                placeholder="Dificultat"
                                style={{ width: '100%' }}
                                allowClear
                                onChange={value => setFilterDifficulty(value)}
                            >
                                <Select.Option value="begginer">Principiante</Select.Option>
                                <Select.Option value="intermediate">Intermedi</Select.Option>
                                <Select.Option value="expert">Expert</Select.Option>
                            </Select>
                        </Col>
                        <Col xs={24} md={4}>
                            <Select
                                placeholder="Estat"
                                style={{ width: '100%' }}
                                allowClear
                                onChange={value => setFilterStatus(value)}
                            >
                                <Select.Option value="hechos">Fet</Select.Option>
                                <Select.Option value="no_hechos">No fet</Select.Option>
                            </Select>
                        </Col>
                        <Col xs={24} md={7}>
                            <Select
                                mode="multiple"
                                placeholder="Filtrar per etiquetes..."
                                style={{ width: '100%' }}
                                allowClear
                                value={filterTags}
                                onChange={value => setFilterTags(value)}
                            >
                                {allTags.map(tag => (
                                    <Select.Option key={tag} value={tag}>{tag}</Select.Option>
                                ))}
                            </Select>
                        </Col>
                        <Col xs={24} md={3} style={{ textAlign: 'right' }}>
                            <Button
                                type="primary"
                                icon={<BiPlus />}
                                style={{
                                    backgroundColor: JutgeColors.colors.color5,
                                    borderColor: JutgeColors.colors.color5,
                                    width: '100%',
                                    fontWeight: 600
                                }}
                                onClick={() => setModalNouVisible(true)}
                            >
                                Proposar
                            </Button>
                        </Col>
                    </Row>
                </Card>

                <Card
                    bordered={false}
                    style={{
                        boxShadow: '0 4px 15px rgba(0,0,0,0.08)',
                        background: '#fff',
                    }}
                >
                    {loading ? (
                        <div style={{ textAlign: 'center', padding: '4rem 0' }}>
                            <Spin size="large" tip="Carregant problemes..." />
                        </div>
                    ) : (
                        <Table
                            {...tableProps}
                            columns={columns}
                            dataSource={filteredDades}
                            showHeader={false}
                            rowKey="id"
                            size='small'
                            bordered={true}
                        />
                    )}
                </Card>
            </Content>

            <Modal
                title={`Intents de tothom - Problema #${selectedProblemId}`}
                open={attemptsModalVisible}
                onCancel={() => setAttemptsModalVisible(false)}
                width={1200}
                footer={null}
                bodyStyle={{ padding: 0 }}
                destroyOnClose
            >
                {selectedProblemId && (
                    <ProblemaIdAlumnes 
                        propIdProblema={selectedProblemId} 
                        propIdActivitat="0" 
                        isModal={true} 
                    />
                )}
            </Modal>

            {modalNouVisible && (
                <NouModal
                    title="Proposar Nou Exercici"
                    element={{ id: 0 }}
                    visible={modalNouVisible}
                    id_activitat="0"
                    onClose={async (refresh: boolean) => {
                        setModalNouVisible(false);
                        if (refresh) await checkDades();
                    }}
                />
            )}
        </>
    );
};

export default Problemes;
